import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "../../../graphql/client";

export const PAGE_SIZE = 50;

export const GET_EMAILS = gql`
  query getEmailsForStream($streamId: Int!) {
    emailsForStream(streamId: $streamId) {
      id
      sender
      mailboxAddress
      receivedAt
    }
  }
`;

export const useEmailsForStream = ({
  streamId
}: {
  streamId: number | null | undefined;
}) => {
  const { data, loading, networkStatus } = useQuery(GET_EMAILS, {
    client: shiftStreamClient,
    variables: {
      streamId: streamId !== null ? streamId : undefined
    },
    skip: !streamId,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    onError: error => {
      throw error;
    }
  });

  // Keep pagination metadata stable while the next page is loading.
  const resolvedData = data;

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    emails: resolvedData?.emailsForStream || []
  };
};
